/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import { getCurrentUser } from 'state/current-user/selectors';
import { Stack } from '@towersystems/towersystems-design-system';
import DetailListItem from 'components/detail-list-item';
import Card from 'components/card';
import DateTime from 'components/date-time';

const CloudHostingDetailsCard = ({ rentalType, hostingExpiry, additionalLicenses }) => {
	return (
		<Card>
			<Stack>
				<Card.Section>
					<DetailListItem label='Cloud Hosting expiry date' detail={<DateTime date={hostingExpiry} format='Do MMM, YYYY' />} />
				</Card.Section>
			</Stack>
		</Card>
	);
};

export default connect((state) => {
	let user = getCurrentUser(state);
	return {
		rentalType: user && user.rentalType,
		additionalLicenses: user && user.additionalLicenses,
		hostingExpiry: user && user.sugarRentalExpiry,
	};
}, {})(CloudHostingDetailsCard);
